import React, { useState, useEffect,CSSProperties} from "react";
import { Tabs,Input,Button} from 'antd'
import { Document, Page,pdfjs } from 'react-pdf/dist/esm/entry.webpack';
import { useSearchParams } from 'react-router-dom';
import ClipLoader from "react-spinners/ClipLoader";
import "react-pdf/dist/esm/Page/TextLayer.css";
import jsPDF from 'jspdf'
import 'svg2pdf.js'
import '../assets/fonts/sohoprolight.js'
import {useAtom} from 'jotai'
import {accessTokenAtom} from "../atoms";


const url = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = url;

const override= {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

function Certificate() {
    const [accessAtom]=useAtom(accessTokenAtom)
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [searchParams] = useSearchParams();
    const [htmlData,sethtmlData]=useState()
    const [params,setParams]=useState({});
    const [loading,setLoading]=useState(true);
    const [downloadFile,setDownloadFile]=useState();
  function onDocumentLoadSuccess({ numPages }) {
    setLoading(false);
  }

  useEffect(()=>{
    
    async function getData(){
      // const response=await fetch(
      //  `${process.env.REACT_APP_API_URL}Certificate/getTemplateV2?certificateNo=${searchParams.get('certificateNo')}&mssl=${searchParams.get('mssl')}&accountNo=${searchParams.get('accountNo')}`
      // )
      // let fetchedData=await response.text();
       // sethtmlData(fetchedData)
       //

      const downloadFile=await fetch(`${process.env.REACT_APP_API_URL}Certificate/DownloadCertificate_v2?certificateNo=${searchParams.get('certificateNo')}&mssl=${searchParams.get('mssl')}&accountNo=${searchParams.get('accountNo')}`,
      {headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    }})
      let fetchedDownloadFile= await downloadFile.blob()
      setDownloadFile(fetchedDownloadFile)
      // setParams({certificateNo:searchParams.get('certificateNo'),mssl:searchParams.get('mssl'),accountNo:searchParams.get('accountNo')})

      setLoading(false)
    }
    setLoading(true);
    getData();
  },[])

  const viewPdf = (pdfData) => {
    // using Java Script method to get PDF file
            // Creating new object of PDF file
            const fileURL = window.URL.createObjectURL(downloadFile);
            // Setting various property values
            let alink = document.createElement('a');
            alink.href = fileURL;
            alink.download = `${searchParams.get('certificateNo')}`;
            alink.click();
    }

  const handlePdfDownload=()=>{
    const containerElement = document.getElementById('container');
    var parser=new DOMParser();
  //const svgElement=containerElement.getElementsByTagName('svg')[0];
    const svgElement=`<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 841.92 595.44">
    <image width="3508" height="2481" transform="scale(.24)"
    xlink:href="Power Eco CC.png" />
    <text transform="translate(316.1 193.54)" fill="#2a317d" font-family="SOHOGOTHICPRO-LIGHT, &apos;Soho Gothic Pro&apos;" font-size="36" font-weight="300"><tspan x="0" y="0"></tspan><tspan x="0" y="43.2" style="font-family:SOHOGOTHICPRO-LIGHT;font-style:normal;font:300;font-size:36px">KEE LEE TAN</tspan></text>
	</svg>`
    var svgDOM=parser.parseFromString(svgElement,'image/svg+xml')
   
  
 
   
    const width = 822.5 
    const height = 581.703125

    

    const pdf = new jsPDF(width > height ? 'l' : 'p', 'pt', [width, height]) 
    pdf.svg(svgDOM.documentElement, {x:1,y:1,width,height}).then(()=>{
      pdf.save('myPDF.pdf')
    })

    
    
    
  }


  return (
    <div className="App">
      {loading==true && (<div style={{   display: 'flex',alignItems: 'center',justifyContent: 'center',height: '100vh'}}>
        <ClipLoader
        color={"#ffffff"}
        loading={loading}
        cssOverride={override}
        size={150}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
      </div>)}
      <div className='row'>
       
        <div className="col d-flex justify-content-start">
      
        {loading==true ? null :
                <Button key="back" onClick={() => viewPdf('pdfData')}>
                Download PDF
              </Button> }
        </div>
      </div>
      
    {/* <div style={{width:'50%',height:'50%'}} id="container" dangerouslySetInnerHTML={{__html:htmlData}} /> */}

    {  <Document file={downloadFile} onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber} renderTextLayer={false} height={document.getElementsByClassName('App')[0]?.clientHeight*0.5} width={document.getElementsByClassName('App')[0]?.clientWidth*0.5}/>
      </Document>} 
     
   
      {/* <Document file={{url:`https://gcs-dev-ms.azurewebsites.net/api/Certificate/DownloadCertificate?certificateNo=${params.certificateNo}&mssl=${params.mssl}&accountNo=${params.accountNo}`}} onLoadSuccess={onDocumentLoadSuccess}>
        <Page pageNumber={pageNumber} renderTextLayer={false}/>
      </Document> */}


    </div>
  )
}

export default Certificate
